import { format } from 'date-fns'
import React, { useState } from 'react'
import DatePicker, { registerLocale } from "react-datepicker"
import fr from 'date-fns/locale/fr'
import ButtonModalClose from './../../elements/ButtonModalClose';
registerLocale('fr',fr)

const ModalAddDaysCloseStaff = ({ _updateDates }) => {
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()

    return (
        <div className="modal fade" id="modalAddDaysCloseStaff">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter une date</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            data-bs-dismiss="modal" 
                            aria-label="Close" 
                            onClick={() => [setStartDate(), setEndDate()]}
                        ></button>
                    </div>
                    <div className="modal-body"> 
                        <div className='text-center mx-5'>
                            <span>début</span>
                            <DatePicker dateFormat='dd/MM/yyyy' className="text-center form-control border-0 rounded-pill shadow p-2 ms-2" locale='fr' selected={startDate} onChange={(date) => setStartDate(date)} />
                        </div>
                        <div className='text-center mt-3 mx-5'>
                            <span>fin</span>
                            <DatePicker dateFormat='dd/MM/yyyy' className="text-center form-control border-0 rounded-pill shadow p-2 ms-2" locale='fr' selected={endDate} onChange={(date) => setEndDate(date)} />
                        </div>
                        <div className='text-center text-danger mt-3'>
                            {startDate > endDate ? 'la date de fin doit être supérieur ou égale' : ''}
                        </div>

                        {/* BUTTON SAVE DATE AND CLOSE MODAL */}
                        <ButtonModalClose
                            disabled={endDate >= startDate ? false : true}
                            onClick={() => [setStartDate(), setEndDate(), _updateDates(startDate, endDate)]}
                            title='Enregistrer'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalAddDaysCloseStaff

